// src/App.js
import React, { useEffect } from 'react'; // <-- IMPORT DO React e useEffect
import LinkTree from './pages/LinkTree';
import PrivacyPage from './pages/PrivacyPolicy';
import Location from './pages/Location';
import CatalogueMenuPage from './pages/CatalogueMenuPage';
import AboutRpg from './pages/about/AboutRpg';
import MenuPage from './pages/MenuPage';
import LoginPage from './pages/LoginPage';
import UserProfilePage from './pages/UserProfilePage';
import SubscriptionPage from './pages/SubscriptionPage';
import TermsPage from './pages/TermsPage';
import ReservationPage from './pages/ReservationPage';
import SignUpPage from './pages/SignUpPage';
import UserReservationsPage from './pages/UserReservationsPage';
import ScrollToTopButton from './components/ScrollToTopButton';
import ReservationDetailsPage from './pages/ReservationDetailsPage';
import AboutPage from './pages/about/About';
import AboutSubscription from './pages/about/AboutSubscription';
import AboutReservation from './pages/about/AboutReservation';
import GameCatalogueV2 from './pages/GameCatalogueV2';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AdminLoginPage from './pages/AdminLoginPage';
import FaqPage from './pages/FaqPage';
import SocialMediaPage from './pages/SocialMediaPage';

import ProtectedRoute from './components/ProtectedRoute'; 
import AdminProtectedRoute from './components/AdminProtectedRoute';

import { AuthProvider } from './context/AuthContext';
import { AdminProvider } from './context/AdminContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";

import './App.css';

const queryClient = new QueryClient();

function App() {
  // =======================================================
  // REDIRECIONAMENTO DE DOMÍNIO
  // =======================================================
  useEffect(() => {
    const hostname = window.location.hostname;
    
    // Verifica se o usuário acessou com ou sem o 'www'
    if (hostname === 'www.delidapersy.com.br' || hostname === 'delidapersy.com.br') {
      // Troca o domínio antigo pelo novo, mantendo o restante da URL (rotas, parâmetros, etc)
      const newUrl = window.location.href.replace(hostname, 'site.delidapersy.com.br');
      
      // Usa replace() para que o usuário não consiga "voltar" para o domínio errado ao clicar no botão de voltar do navegador
      window.location.replace(newUrl);
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AdminProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LinkTree />} />
            <Route path="/social" element={<SocialMediaPage />} />
            <Route path="/*" element={<MainLayout />}/>
          </Routes>
        </Router>
      </AuthProvider>
    </AdminProvider>
    </QueryClientProvider>
    
  );
}

function MainLayout() {
  return (
    <div className="main-layout-container"> 
      <Header />
      
      <main className="main-content"> 
        <Routes>
          {/* ======================================================= */}
          {/* ROTAS PÚBLICAS (Visíveis para todos)                      */}
          {/* ======================================================= */}
          <Route path="politica-de-privacidade" element={<PrivacyPage />} />
          <Route path="local" element={<Location />} />
          <Route path="biblioteca" element={<CatalogueMenuPage />} />
          <Route path="biblioteca/acervo" element={<GameCatalogueV2 />} />
          <Route path="cardapio" element={<MenuPage />} />
          <Route path="termos-de-uso" element={<TermsPage />} />
          
          {/* A Rota de Login Admin é a única de autenticação pública agora */}
          <Route path="admin-login" element={<AdminLoginPage />} />

          {/* ======================================================= */}
          {/* PREVIEW ADMIN (Exigem estar logado como Admin no momento) */}
          {/* ======================================================= */}
          <Route path="login" element={<AdminProtectedRoute><LoginPage /></AdminProtectedRoute>} /> 
          <Route path="signup" element={<AdminProtectedRoute><SignUpPage /></AdminProtectedRoute>} /> 
          
          <Route path="sobre" element={<AdminProtectedRoute><AboutPage /></AdminProtectedRoute>} />
          <Route path="sobre/rpg" element={<AdminProtectedRoute><AboutRpg /></AdminProtectedRoute>} />
          <Route path="sobre/assinatura" element={<AdminProtectedRoute><AboutSubscription /></AdminProtectedRoute>} />
          <Route path="sobre/reserva" element={<AdminProtectedRoute><AboutReservation /></AdminProtectedRoute>} />
          <Route path="faq" element={<AdminProtectedRoute><FaqPage /></AdminProtectedRoute>} />

          <Route path="usuario" element={
            <AdminProtectedRoute>
              <ProtectedRoute>
                <UserProfilePage />
              </ProtectedRoute>
            </AdminProtectedRoute>
          } /> 
          
          <Route path="assinatura" element={
            <AdminProtectedRoute>
              <ProtectedRoute>
                <SubscriptionPage />
              </ProtectedRoute>
            </AdminProtectedRoute>
          } />
          
          <Route path="reserva" element={
            <AdminProtectedRoute>
              <ProtectedRoute>
                <ReservationPage />
              </ProtectedRoute>
            </AdminProtectedRoute>
          } />
          
          <Route path="minhas-reservas" element={
            <AdminProtectedRoute>
              <ProtectedRoute>
                <UserReservationsPage />
              </ProtectedRoute>
            </AdminProtectedRoute>
          } />
          
          <Route path="/reserva/:id" element={
            <AdminProtectedRoute>
              <ProtectedRoute>
                <ReservationDetailsPage />
              </ProtectedRoute>
            </AdminProtectedRoute>
          } />
            
        </Routes>
      </main>
      
      <Footer />
      <ScrollToTopButton /> 
    </div>
  );
}

export default App;